export const weightLossNavigationItems: NavigationItem[] = [
  {
    title: "Home",
    url: "", // not used, dynamicUrl is used
    dynamicUrl: (program: string) => `/dashboard/${program}`,
    matchUrls: (program: string) => [
      `/dashboard/${program}`,
      `/dashboard/${program}/todos`,
      `/dashboard/${program}/todos/consultations`,
      `/dashboard/${program}/todos/appointments`,
      `/dashboard/${program}/todos/refills`,
    ],
  },
  {
    title: "Calendar",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}/calendar`,
    matchUrls: (program: string) => [`/dashboard/${program}/calendar`],
  },
  {
    title: "Encounters",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}/encounters`,
    matchUrls: (program: string) => [`/dashboard/${program}/encounters`, `/dashboard/${program}/encounters/`],
  },
  {
    title: "Patients",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}/patients`,
    matchUrls: (program: string) => [`/dashboard/${program}/patients`],
  },
  {
    title: "Payments",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}/payments`,
    matchUrls: (program: string) => [
      `/dashboard/${program}/payments`,
      `/dashboard/${program}/payments/consultations`,
      `/dashboard/${program}/payments/appointments`,
      `/dashboard/${program}/payments/refills`,
    ],
  },
];

export const urgentCareNavigationItems: NavigationItem[] = [
  {
    title: "Home",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}`,
    matchUrls: (program: string) => [
      `/dashboard/${program}`,
      `/dashboard/${program}/todos`,
      `/dashboard/${program}/todos/consultations`,
      `/dashboard/${program}/todos/appointments`,
      `/dashboard/${program}/todos/refills`,
    ],
  },
  {
    title: "Calendar",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}/calendar`,
    matchUrls: (program: string) => [`/dashboard/${program}/calendar`],
  },
  {
    title: "Encounters",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}/encounters`,
    matchUrls: (program: string) => [`/dashboard/${program}/encounters`, `/dashboard/${program}/encounters/`],
  },
  {
    title: "Patients",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}/patients`,
    matchUrls: (program: string) => [`/dashboard/${program}/patients`],
  },
  {
    title: "Payments",
    url: "",
    dynamicUrl: (program: string) => `/dashboard/${program}/payments`,
    matchUrls: (program: string) => [
      `/dashboard/${program}/payments`,
      `/dashboard/${program}/payments/consultations`,
      `/dashboard/${program}/payments/appointments`,
      `/dashboard/${program}/payments/refills`,
    ],
  },
];


export const platformSwitchItems = [
  {
    title: "Weight Loss",
    platform: "weight-loss",
    url: "/dashboard/weight-loss",
    disabled: false
  },
  {
    title: "Urgent Care",
    platform: "urgent-care",
    url: "/dashboard/urgent-care",
    disabled: false
  },
]

export type NavigationItem = {
  title: string;
  description?: string;
  url: string;
  matchUrls?: string[] | ((program: string) => string[]);
  icon?: React.ReactNode;
  notifications?: number;
  program?: string;
  disabled?: boolean;
  dynamicUrl?: (program: string) => string;
  isDynamicRoute?: boolean;
};

